import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserMenu from '../components/usermenu';
import UserDetails from './userDetails';
import WarehouseBookingList from './userBooking'; // Ensure this component is properly imported
import WishList from './userWishlist';

function AdminRoutes() {
    return (
        <div className='container-fluid mt-4'>
            <div className='row'>
                {/* Sidebar - 2 columns */}
                <div className='col-2 p-0'>
                    <UserMenu /> {/* Sidebar is always shown on admin routes */}
                </div>

                {/* Main content area - 10 columns */}
                <div className='col-10 user-content pt-5'>
                    <Routes>
                        {/* Default route */}
                        <Route path="/" element={<UserDetails />} />

                        {/* Booking list route */}
                        <Route path="/bookingList" element={<WarehouseBookingList />} />
                        <Route path='/userWishList' element={<WishList />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default AdminRoutes;
